import { TScreening } from '../model/types'

export const competitorBadActorReviewKeys = {
  all: ['competitor-bad-actor-review-form'] as const,
  result: (requestId: number, screening: TScreening) =>
    [...competitorBadActorReviewKeys.all, 'result', requestId, screening] as const,
  rerun: (requestId: number, screening: TScreening, run: number) =>
    [...competitorBadActorReviewKeys.all, 'rerun', requestId, screening, run] as const,
}
